const PapperIcon: React.FC = props => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_8074_7817"
      style={{
        maskType: 'alpha'
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={48}
      height={48}
    >
      <rect width={48} height={48} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_8074_7817)">
      <path
        d="M16 36H32V32H16V36ZM16 28H32V24H16V28ZM12 44C10.9 44 9.95833 43.6083 9.175 42.825C8.39167 42.0417 8 41.1 8 40V8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4H28L40 16V40C40 41.1 39.6083 42.0417 38.825 42.825C38.0417 43.6083 37.1 44 36 44H12ZM26 18V8H12V40H36V18H26Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
)
export default PapperIcon
